import { createSelector } from 'reselect';
import { getSessionToken } from '@clearscore/helpers.session';

const sessionToken = (state) => getSessionToken({ state });

export default createSelector(sessionToken, (session) => session);
